import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('intializeEditorViewOutsideOrgState', function intializeEditorViewOutsideOrgState() {
    var editorViewState = getStore().currentState.editorViewStateOutsideOrg;
    var initialEditorViewState = getStore().initialState.editorViewStateOutsideOrg;
    editorViewState.content = initialEditorViewState.content;
});
//# sourceMappingURL=intializeEditorViewOutsideOrgState.js.map